import { Component, EventEmitter, Output } from '@angular/core';
import { AnnuityDialogComponent } from '../../../annuity-lookup/annuity-dialog/annuity-dialog.component';

@Component({
  selector: 'app-product-shelf-compare-lookup',
  imports: [AnnuityDialogComponent],
  templateUrl: './product-shelf-compare-lookup.component.html',
  styleUrl: './product-shelf-compare-lookup.component.scss',
})
export class ProductShelfCompareLookupComponent {
  @Output() compareTemplateData = new EventEmitter();

  addTemplateData(ev) {
    this.compareTemplateData.emit(ev);
  }
}
